/** Chiave sessionStorage per l'URL di ritorno dopo il flusso SSO (login o 401). */
export const SSO_RETURN_URL_KEY = 'sso_return_url';

/** Chiave sessionStorage per il conteggio tentativi di redirect verso Auth-App (evita loop). */
export const SSO_REDIRECT_ATTEMPTS_KEY = 'sso_redirect_attempts';

/** Chiave sessionStorage per il target_app corretto estratto dall'URL quando viene ricevuto il ticket. */
export const SSO_TARGET_APP_KEY = 'sso_target_app';

/** Chiave sessionStorage per indicare che siamo in fase di logout/redirect verso Auth-App (evita redirect multipli dall'interceptor). */
export const SSO_LOGOUT_IN_PROGRESS_KEY = 'sso_logout_in_progress';

/** Chiave sessionStorage per indicare che siamo già in fase di redirect verso Auth-App per login (evita redirect multipli dall'interceptor su 401). */
export const SSO_REDIRECT_IN_PROGRESS_KEY = 'sso_redirect_in_progress';

/** Chiave sessionStorage per richiedere fast-refresh del token quando scaduto (utente già autenticato). */
export const SSO_TOKEN_REFRESH_REQUIRED_KEY = 'sso_token_refresh_required';

/** Path Auth-App per la pagina di login. */
export const SSO_AUTH_APP_PATH_LOGIN = '/login';

/** Path Auth-App per la pagina di refresh rapido del token. */
export const SSO_AUTH_APP_PATH_FAST_REFRESH = '/sso-fast';

/** Path Auth-App per la landing page. */
export const SSO_AUTH_APP_PATH_LANDING = '/landing-page';
